(function () {
  var DEFAULT_RESET = {
    opacity: 0,
    xPercent: 0,
    yPercent: 0,
    scale: 1,
    filter: "blur(0px)",
  };
  var ACTIVE = {
    opacity: 1,
    xPercent: 0,
    yPercent: 0,
    scale: 1,
    filter: "blur(0px)",
  };

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function shuffleSlides(slides) {
    var result = slides.slice();
    for (var i = result.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = result[i];
      result[i] = result[j];
      result[j] = temp;
    }
    return result;
  }

  function getEffectVars(effect, scale, blur, distance) {
    var fromVars = Object.assign({}, DEFAULT_RESET);
    var activeVars = Object.assign({}, ACTIVE);
    var exitVars = Object.assign({}, DEFAULT_RESET);

    if (effect === "zoom") {
      fromVars.scale = scale;
      exitVars.scale = 1 + (scale - 1) * 0.4;
    }

    if (effect === "blur") {
      fromVars.filter = "blur(" + blur + "px)";
      exitVars.filter = "blur(" + Math.max(blur * 0.5, 0) + "px)";
    }

    if (effect === "slide_left") {
      fromVars.xPercent = distance;
      exitVars.xPercent = -distance;
    } else if (effect === "slide_right") {
      fromVars.xPercent = -distance;
      exitVars.xPercent = distance;
    } else if (effect === "slide_up") {
      fromVars.yPercent = distance;
      exitVars.yPercent = -distance;
    } else if (effect === "slide_down") {
      fromVars.yPercent = -distance;
      exitVars.yPercent = distance;
    }

    return {
      from: fromVars,
      active: activeVars,
      exit: exitVars,
    };
  }

  function getTransform(vars) {
    return (
      "translate(" +
      (vars.xPercent || 0) +
      "%, " +
      (vars.yPercent || 0) +
      "%) scale(" +
      (vars.scale || 1) +
      ")"
    );
  }

  function applyFallbackVars(slide, vars, zIndex) {
    slide.style.opacity = vars.opacity;
    slide.style.zIndex = zIndex;
    slide.style.transform = getTransform(vars);
    slide.style.filter = vars.filter || "blur(0px)";
  }

  function resetInlineSlideState(slides) {
    slides.forEach(function (slide, index) {
      slide.style.opacity = index === 0 ? "1" : "";
      slide.style.zIndex = index === 0 ? "1" : "";
      slide.style.transform = "";
      slide.style.filter = "";
      slide.style.transition = "";
      slide.style.transformOrigin = "";
    });
  }

  function isSlideVisible(slide) {
    // 모바일 전용/PC 전용 이미지는 반대 화면에서 display:none 이라 디졸브 대상에서 뺀다
    return window.getComputedStyle(slide).display !== "none";
  }

  function showStaticSlide(allSlides, activeSlide) {
    resetInlineSlideState(allSlides);
    allSlides.forEach(function (slide) {
      var isActive = slide === activeSlide;
      slide.style.opacity = isActive ? "1" : "0";
      slide.style.zIndex = isActive ? "1" : "0";
      slide.style.position = isActive ? "relative" : "absolute";
    });
  }

  function syncNavigationVisibility(section, visibleCount) {
    var buttons = section.querySelectorAll(
      "[data-image-dissolve-navigation-button]",
    );

    buttons.forEach(function (button, index) {
      button.style.display = index < visibleCount ? "" : "none";
    });
  }

  function createController(section) {
    var controller = {
      fallbackTimers: [],
      gsapAnimations: [],
      hoverEnter: null,
      hoverLeave: null,
      navigationClick: null,
      timeline: null,
    };

    section._imageDissolveController = controller;
    return controller;
  }

  function cleanupImageSectionDissolve(section) {
    var controller = section._imageDissolveController;
    var legacyTimeline = section._imageDissolveTimeline;

    if (legacyTimeline) {
      legacyTimeline.kill();
      section._imageDissolveTimeline = null;
    }

    if (section._imageDissolveFallbackTimer) {
      window.clearTimeout(section._imageDissolveFallbackTimer);
      section._imageDissolveFallbackTimer = null;
    }

    if (section._imageDissolveHoverEnter) {
      section.removeEventListener(
        "mouseenter",
        section._imageDissolveHoverEnter,
      );
      section.removeEventListener(
        "mouseleave",
        section._imageDissolveHoverLeave,
      );
      section._imageDissolveHoverEnter = null;
      section._imageDissolveHoverLeave = null;
    }

    if (!controller) return;

    if (controller.timeline) {
      controller.timeline.kill();
      controller.timeline = null;
    }

    controller.gsapAnimations.forEach(function (animation) {
      animation.kill();
    });
    controller.gsapAnimations = [];

    controller.fallbackTimers.forEach(function (timer) {
      window.clearTimeout(timer);
    });
    controller.fallbackTimers = [];

    if (controller.hoverEnter) {
      section.removeEventListener("mouseenter", controller.hoverEnter);
      section.removeEventListener("mouseleave", controller.hoverLeave);
      controller.hoverEnter = null;
      controller.hoverLeave = null;
    }

    if (controller.navigationClick) {
      section.removeEventListener("click", controller.navigationClick);
      controller.navigationClick = null;
    }

    section._imageDissolveController = null;
  }

  function updateNavigation(section, slides, activeSlide) {
    var buttons = section.querySelectorAll(
      "[data-image-dissolve-navigation-button]",
    );
    var activeIndex = slides.indexOf(activeSlide);

    buttons.forEach(function (button, index) {
      var isActive = index === activeIndex;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-current", isActive ? "true" : "false");
    });
  }

  function bindNavigation(section, controller) {
    if (
      !section.querySelector("[data-image-dissolve-navigation-button]")
    ) {
      return;
    }

    controller.navigationClick = function (event) {
      var button = event.target.closest(
        "[data-image-dissolve-navigation-button]",
      );
      if (!button || !section.contains(button)) return;

      var requestedIndex = toInt(button.dataset.slideIndex, 0);
      initDissolveSection(section, requestedIndex);
    };
    section.addEventListener("click", controller.navigationClick);
  }

  function readConfig(section) {
    var config = {
      interval: toNumber(section.dataset.dissolveInterval, 4),
      delay: toNumber(section.dataset.dissolveDelay, 0),
      duration: toNumber(section.dataset.dissolveDuration, 0.8),
      effect: section.dataset.dissolveEffect || "fade",
      ease: section.dataset.dissolveEase || "power1.inOut",
      scale: toNumber(section.dataset.dissolveScale, 1.1),
      blur: toInt(section.dataset.dissolveBlur, 0),
      distance: toInt(section.dataset.dissolveDistance, 0),
      order: section.dataset.dissolveOrder || "normal",
      loop: section.dataset.dissolveLoop !== "false",
      pauseHover: section.dataset.dissolvePauseHover === "true",
    };

    if (getDesignMode()) {
      config.pauseHover = false;
    }

    return config;
  }

  function getOrderedSlides(slides, order) {
    if (order === "reverse") return slides.slice().reverse();
    if (order === "random") return shuffleSlides(slides);
    return slides.slice();
  }

  function bindHoverPause(section, controller, onPause, onResume) {
    controller.hoverEnter = onPause;
    controller.hoverLeave = onResume;
    section.addEventListener("mouseenter", controller.hoverEnter);
    section.addEventListener("mouseleave", controller.hoverLeave);
  }

  function scheduleFallback(controller, callback, delay) {
    var timer = window.setTimeout(function () {
      controller.fallbackTimers = controller.fallbackTimers.filter(
        function (item) {
          return item !== timer;
        },
      );
      callback();
    }, delay * 1000);
    controller.fallbackTimers.push(timer);
    return timer;
  }

  function trackGsapAnimation(controller, animation) {
    controller.gsapAnimations.push(animation);
    return animation;
  }

  function untrackGsapAnimation(controller, animation) {
    controller.gsapAnimations = controller.gsapAnimations.filter(
      function (item) {
        return item !== animation;
      },
    );
  }

  function scheduleGsap(controller, gsap, callback, delay) {
    var animation = gsap.delayedCall(delay, function () {
      untrackGsapAnimation(controller, animation);
      callback();
    });
    return trackGsapAnimation(controller, animation);
  }

  function pauseGsapAnimations(controller) {
    controller.gsapAnimations.forEach(function (animation) {
      animation.pause();
    });
  }

  function resumeGsapAnimations(controller) {
    controller.gsapAnimations.forEach(function (animation) {
      animation.resume();
    });
  }

  function initFallbackDissolve(
    section,
    controller,
    slides,
    orderedSlides,
    vars,
    config,
  ) {
    var currentIndex = 0;
    var isPaused = false;
    var transition =
      "opacity " +
      config.duration +
      "s ease, transform " +
      config.duration +
      "s ease, filter " +
      config.duration +
      "s ease";

    slides.forEach(function (slide) {
      slide.style.transition = transition;
      slide.style.transformOrigin = "50% 50%";
      applyFallbackVars(slide, DEFAULT_RESET, 0);
    });
    applyFallbackVars(orderedSlides[0], vars.active, 1);
    updateNavigation(section, slides, orderedSlides[0]);

    function showNext() {
      if (isPaused) {
        scheduleFallback(controller, showNext, config.interval);
        return;
      }

      var current = orderedSlides[currentIndex];
      if (!config.loop && currentIndex >= orderedSlides.length - 1) return;

      var nextIndex = (currentIndex + 1) % orderedSlides.length;
      var next = orderedSlides[nextIndex];

      applyFallbackVars(next, vars.from, 2);

      window.requestAnimationFrame(function () {
        applyFallbackVars(next, vars.active, 2);
        applyFallbackVars(current, vars.exit, 1);
      });

      scheduleFallback(
        controller,
        function () {
          applyFallbackVars(current, DEFAULT_RESET, 0);
          applyFallbackVars(next, vars.active, 1);
          updateNavigation(section, slides, next);
          scheduleFallback(controller, showNext, config.interval);
        },
        config.duration,
      );

      currentIndex = nextIndex;
    }

    scheduleFallback(controller, showNext, config.interval + config.delay);

    if (config.pauseHover) {
      bindHoverPause(
        section,
        controller,
        function () {
          isPaused = true;
        },
        function () {
          isPaused = false;
        },
      );
    }
  }

  function initGsapDissolve(
    section,
    controller,
    slides,
    orderedSlides,
    vars,
    config,
  ) {
    var gsap = window.gsap;
    var currentIndex = 0;

    gsap.killTweensOf(slides);
    gsap.set(
      slides,
      Object.assign({}, DEFAULT_RESET, {
        zIndex: 0,
        transformOrigin: "50% 50%",
      }),
    );
    gsap.set(orderedSlides[0], Object.assign({}, vars.active, { zIndex: 1 }));
    updateNavigation(section, slides, orderedSlides[0]);

    function transitionToNext() {
      var current = orderedSlides[currentIndex];
      if (!config.loop && currentIndex >= orderedSlides.length - 1) return;

      var nextIndex = (currentIndex + 1) % orderedSlides.length;
      var next = orderedSlides[nextIndex];

      gsap.set(next, Object.assign({}, vars.from, { zIndex: 2 }));

      var nextTween = gsap.to(
        next,
        Object.assign({}, vars.active, {
          duration: config.duration,
          ease: config.ease,
          overwrite: true,
        }),
      );
      trackGsapAnimation(controller, nextTween);
      nextTween.eventCallback("onComplete", function () {
        untrackGsapAnimation(controller, nextTween);
      });

      var currentTween = gsap.to(
        current,
        Object.assign({}, vars.exit, {
          duration: config.duration,
          ease: config.ease,
          overwrite: true,
        }),
      );
      trackGsapAnimation(controller, currentTween);
      currentTween.eventCallback("onComplete", function () {
        gsap.set(current, Object.assign({}, DEFAULT_RESET, { zIndex: 0 }));
        gsap.set(next, Object.assign({}, vars.active, { zIndex: 1 }));
        updateNavigation(section, slides, next);
        currentIndex = nextIndex;
        untrackGsapAnimation(controller, currentTween);
        scheduleGsap(controller, gsap, transitionToNext, config.interval);
      });
    }

    scheduleGsap(
      controller,
      gsap,
      transitionToNext,
      config.interval + config.delay,
    );

    if (config.pauseHover) {
      bindHoverPause(
        section,
        controller,
        function () {
          pauseGsapAnimations(controller);
        },
        function () {
          resumeGsapAnimations(controller);
        },
      );
    }
  }

  function initDissolveSection(section, requestedIndex) {
    var allSlides = Array.prototype.slice.call(
      section.querySelectorAll("[data-image-dissolve-slide]"),
    );
    if (allSlides.length < 2) return;

    cleanupImageSectionDissolve(section);

    // 현재 화면(PC/모바일)에서 실제로 보이는 슬라이드만 돌린다.
    // 모바일 전용 이미지만 2장 이상인 섹션이 PC에서 빈 화면으로 전환되던 문제를 막는다.
    var slides = allSlides.filter(isSlideVisible);
    syncNavigationVisibility(section, slides.length);

    if (slides.length < 2) {
      showStaticSlide(allSlides, slides[0]);
      updateNavigation(section, slides, slides[0]);
      return;
    }

    allSlides.forEach(function (slide) {
      if (slides.indexOf(slide) === -1) slide.style.opacity = "0";
    });

    var controller = createController(section);
    var config = readConfig(section);
    var orderedSlides = getOrderedSlides(slides, config.order);
    var requestedOrderIndex = -1;
    var vars = getEffectVars(
      config.effect,
      config.scale,
      config.blur,
      config.distance,
    );

    if (Number.isInteger(requestedIndex) && slides[requestedIndex]) {
      requestedOrderIndex = orderedSlides.indexOf(slides[requestedIndex]);
    }

    if (requestedOrderIndex > 0) {
      orderedSlides = orderedSlides
        .slice(requestedOrderIndex)
        .concat(orderedSlides.slice(0, requestedOrderIndex));
    }

    bindNavigation(section, controller);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var reducedMotionSlide =
        Number.isInteger(requestedIndex) && slides[requestedIndex]
          ? slides[requestedIndex]
          : slides[0];

      resetInlineSlideState(slides);
      slides.forEach(function (slide) {
        slide.style.opacity = slide === reducedMotionSlide ? "1" : "0";
        slide.style.zIndex = slide === reducedMotionSlide ? "1" : "0";
      });
      updateNavigation(section, slides, reducedMotionSlide);
      return;
    }

    if (typeof window.gsap === "undefined") {
      initFallbackDissolve(
        section,
        controller,
        slides,
        orderedSlides,
        vars,
        config,
      );
      return;
    }

    initGsapDissolve(
      section,
      controller,
      slides,
      orderedSlides,
      vars,
      config,
    );
  }

  function initImageSectionDissolve(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll("[data-image-dissolve]");

    sections.forEach(function (section) {
      initDissolveSection(section);
    });
  }

  window.FilaImageSectionDissolve = initImageSectionDissolve;

  if (window.FilaImageSectionDissolveBound) {
    initImageSectionDissolve(document);
    return;
  }

  window.FilaImageSectionDissolveBound = true;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initImageSectionDissolve(document);
    });
  } else {
    initImageSectionDissolve(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initImageSectionDissolve(event.target);
  });

  // 브라우저 폭이 PC/모바일 경계를 넘나들면 보이는 슬라이드가 달라지므로 다시 판단한다.
  var dissolveBreakpoint = window.matchMedia("(max-width: 768px)");
  var handleDissolveBreakpoint = function () {
    initImageSectionDissolve(document);
  };

  if (dissolveBreakpoint.addEventListener) {
    dissolveBreakpoint.addEventListener("change", handleDissolveBreakpoint);
  } else if (dissolveBreakpoint.addListener) {
    dissolveBreakpoint.addListener(handleDissolveBreakpoint);
  }

  document.addEventListener("shopify:section:unload", function (event) {
    var sections = event.target.querySelectorAll("[data-image-dissolve]");
    sections.forEach(cleanupImageSectionDissolve);
  });
})();
